import { render } from "./StatistiqueGlobalPage.vue?vue&type=template&id=51188958&ts=true"
import script from "./StatistiqueGlobalPage.vue?vue&type=script&lang=ts"
export * from "./StatistiqueGlobalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__